export default "__VITE_ASSET__43ebe168__"